import { render } from "./DetailsEmptyState.vue?vue&type=template&id=27e77941"
import script from "./DetailsEmptyState.vue?vue&type=script&lang=js"
export * from "./DetailsEmptyState.vue?vue&type=script&lang=js"

import "./DetailsEmptyState.vue?vue&type=style&index=0&id=27e77941&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__